const VIEW_TYPES = {
  dashboard: "Dashboard",
  card: "Card",
  modal: "Modal",
  section: "Section",
  banner: "Banner",
}

export default VIEW_TYPES
